module.exports = __webpack_public_path__ + "static/media/Agility.bd3e28db.svg";